import React from 'react'
import { useSelector } from 'react-redux'
import { $t } from '../../../i18n'
import { getIsHmoMember } from '../../../utils/hmoUtils'

import './NotInsuredLabel.css'

export const NotInsuredLabel = ({ className, patientId }) => {
  const { activeMembers } = useSelector(state => state.account)
  const userDetails = useSelector(state => state.profile.userDetails)

  const isSelf = userDetails?.id?.toString() === patientId?.toString()

  const isOwnerHmo = !!getIsHmoMember(userDetails)

  const currentPatient = isSelf
    ? userDetails
    : activeMembers?.find(
        patient => patient?.id?.toString() === patientId?.toString()
      )
  const isInsured =
    !currentPatient || !!currentPatient?.hmo_member_id || !isOwnerHmo
  if (isInsured) return null
  return (
    <div className={`not-insured-label ${className}`}>
      <span className="not-insured-text tiny semi-bold">
        {$t('common.notInsured')}
      </span>
    </div>
  )
}

export default NotInsuredLabel
